import s from './design_system/state'
import * as a from './design_system/actions'
import * as m from './design_system/mutations'
import * as g from './design_system/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
